import { erStatic } from '../static-all';
import { reduceToMap } from '$lib/utils/array';
import { immediateDerived } from '$lib/store';
import type ERAR from '$lib/erar/spec';

export const idToArea = immediateDerived(
  erStatic,
  (values) => {
    return reduceToMap(
      values?.result.areas ?? [],
      (v) => v.id,
      (v) => {
        // HACK: API 오타
        if (v.name === 'Hotal') {
          v.name = 'Hotel';
        }
        return v;
      },
    );
  },
  new Map<number, ERAR.Schema.StaticAreaList[number]>(),
);

export const nameToArea = immediateDerived(
  idToArea,
  (value) => {
    return reduceToMap(
      [...value.values()],
      (v) => v.name,
      (v) => v,
    );
  },
  new Map<string, ERAR.Schema.StaticAreaList[number]>(),
);

export const visitableAreas = immediateDerived(
  idToArea,
  (value) => [...value.values()].filter((v) => v.id < 1000),
  [],
);
